// extracted by mini-css-extract-plugin
module.exports = {"inspirational":"Grid_inspirational__IpHh0","standard":"Grid_standard__xt7_3","overview":"Grid_overview___rpEH","grid":"Grid_grid__fLhp5"};